<template>
  <div class="customViewFormInfo">
    <el-row class="customYjzhDetail">
      <div v-for="(item,index) in formConfig" :class="itemWidth(item.span)" :key="'customView'+index"  class="el-col"
      :style="{borderLeft:chartConfig.borderLeft,borderTop:chartConfig.borderTop
      ,borderBottom:chartConfig.borderBottom,borderRight:chartConfig.borderRight}">
        <div class="itemClass" style="width: 100%;height:100%;"
        :style="{paddingTop:getPadding(),paddingBottom:getPadding()}">
          <label class="label" style="height:100%" :style="{fontWeight:chartConfig.labelFontWeight,color:chartConfig.labelColor,fontFamily:chartConfig.labelFontFamiy, width:getlableWidth(),fontSize:getLabelFontSize()}" :title="item.label"  >{{ item.label }}</label>
          <div :style="{marginLeft:getlableWidth(item.labelWidth)}"
           class="item" style="padding-left:4px;text-align: left;">
            <div v-if="item.type=='images'">
              <el-image v-for="(item2,index2) in formModel[item.prop]" :key="getImageKey(index2)" style="width: 100px; height: 100px" :src="getImagesUrl(item2)" :preview-src-list="getImagesUrlList(formModel[item.prop])" :z-index="index2">
              </el-image>
            </div>
            <div v-else-if="item.type=='imagesOrVideo'">
              <div style="padding:0;overflow-y: auto;" class="itemTextAreaClass "
              :style="{height:getControlHeight(item.height),borderLeft:item.border,borderRight:item.border,borderTop:item.border,borderBottom:item.border}">
                <template v-for="(item2,index2) in formModel[item.prop]">
                    <el-col :span="7" :offset="1"   :key="getImageKey(index2)">
                        <el-image  v-if="item2.fjType==='image'"
                        :key="getImageKey(index2)"
                         :z-index="index2"
                         fit="contain"
                         :preview-src-list="getImageList(item)"
                         style="padding-left:10px"
                         :style="{height:getControlHeight(item.height)}"
                         :src="getImagePath(item2)">
                        </el-image>
                        <VideoHls v-else width="100%" style="padding-left:5px;"
                         :height="getControlHeight(item.height)"  :chartConfig="getVideoChartConfig(item2)" >
                        </VideoHls>
                    </el-col>
                </template>
              </div>

            </div>
            <div style="width:100%;" :title="formModel[item.prop]" class="itemTextAreaClass"
             :style="{fontSize:getControlFontSize(),fontWeight:chartConfig.labelFontWeight,color:chartConfig.labelColor,fontFamily:chartConfig.labelFontFamiy}" v-else-if="item.type=='textarea'">
              <div style="padding:10px;overflow-y: auto;" class="itemTextAreaClass "
              :style="{height:getControlHeight(item.height),borderLeft:item.border,borderRight:item.border,borderTop:item.border,borderBottom:item.border}">
                {{ formModel[item.prop] }}
              </div>
             </div>
            <div style="width:100%;height:100%;" :title="formModel[item.prop]" class="itemClass"
             :style="{fontSize:getControlFontSize(),fontWeight:chartConfig.labelFontWeight,color:chartConfig.labelColor,fontFamily:chartConfig.labelFontFamiy}" v-else>{{ formModel[item.prop] }}</div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row style="text-align: right;">
        <el-button v-for="(btnConfig,index) in btnConfigs" :key="'btn'+index"
        :style="{fontSize:getBtnFontSize(btnConfig),
          fontWeight:btnConfig.fontWeight,
          marginTop:getBtnMarginTop(btnConfig),
          color:btnConfig.color,
          border:btnConfig.border,
          borderRadius:btnConfig.borderRadius,
          width:getBtnWidth(btnConfig),
          height:getBtnHeight(btnConfig),
          backgroundImage:btnConfig.backgroundImage,
          backgroundColor:btnConfig.backgroundColor}" @click="openPaifa(btnConfig)">派发</el-button>
    </el-row>
  </div>
</template>
<script>
import {getDataService} from '../../api/chart/chart/index.js'
import lodash from 'lodash'
import fwUtil from 'framework-util'
import VideoHls from '../images/VideoHls.vue'
  export default {
    name: 'BaseViewForm',
    components: {VideoHls},
    props: {
      formConfig:{
        type:Array,
        default(){
          return []
        }
      },
      formData:{
        type:Object,
        default(){
          return {}
        }
      },
      queryConfig:{
        type:Object,
        default(){
          return {
            url:null,
            params:[]
          }
        }
      },
      btnConfigs:{
       type:Array,
       default(){
         return []
       }
      },
      chartConfig:{
         type:Object,
         default(){
           return {
             queryUrl:null,
             queryParam:[],
             labelWidth:'100px',
             controlFontSize:14,
             labelFontSize:14,
             labelColor:'#fff',
             labelFontFamiy:'',
             labelFontWeight:'normal',
             borderLeft:'',
             borderRight:'',
             controlFontSize:14,
             controlColor:'#fff',
             controlFontFamiy:'',
             controlFontWeight:'normal',
             background:'',
             borderTop:'',
             borderBottom:''
           }
         }
      },
      title:{
        type:String,
        default:null
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      }
    },
    data() {
      return {
        formModel: {},
        elCol: 24
      }
    },
    computed: {

    },
    watch: {
      formData:{
        handler(newValue,oldValue){
           this.formModel = lodash.cloneDeep(newValue)
        },
        deep:true
      },
      queryConfig:{
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      }
    },
    mounted() {
      this.formModel = lodash.cloneDeep(this.formData)
      // 将组件上的属性赋值给当前组件内变量，因为props只能单向绑定,还需要监听属性值变化进行父子组件间交互
      this.getData()
    },

    methods: {
      getImageList(item){
        let imageList=[]
        if(this.formModel[item.prop]){
          let data=this.formModel[item.prop]
          for(let i=0;i<data.length;i++){
            if(data[i].fjType=='image'){
              if(data[i].path){
                imageList.push(data[i].path)
              }

            }
          }
        }
        return imageList;
      },
      getImagePath(item){
        return item.path;
      },
      getVideoChartConfig(item){
        let config={
          videoSrc:item.path,
          type:'video/mp4'
        }
        return config;
      },
      isImageType(file){
        let flag=fwUtil.Helper.IsImageService(file)
        console.info("flag===="+flag)
        return flag;
      },
      openPaifa(config){
        if(config.type==='send'){
          this.$emit("sendParam",this.formModel,config.url)
        }
      },
      getData(){
        let that=this
        if(this.queryConfig && this.queryConfig.url){
          let url=this.queryConfig.url
          let params={}
          if(this.queryConfig.params){
            for(let i=0;i<this.queryConfig.params.length;i++){
              if(this.queryConfig.params[i].target
               && this.queryConfig.params[i].source){
                 let _value=fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
                 if(_value){
                   params[this.queryConfig.params[i].target]=_value
                 }
               }
            }
          }
          getDataService(url,params).then((res)=>{
            that.formModel=res
            that.$emit("loadData",that.formModel)
          })
        }
      },
      getBtnMarginTop(btnConfig){
        let _height=btnConfig.marginTop?btnConfig.marginTop:0
        if(_height.toString().indexOf('px')>=0){
          _height=_height.toString().replace("px","")
        }
        if(_height.toString().indexOf("%")>=0){
          _height=_height.toString().replace("%","")
        }
        _height=parseInt(_height)
        let height = _height / this.page.height * this.screen.height
        return height + 'px'

      },
      getBtnFontSize(btnConfig) {
        let _height = btnConfig.fontSize ? btnConfig.fontSize : 14;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      getBtnHeight(btnConfig) {
        let _height = btnConfig.height ? btnConfig.height : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getBtnWidth(btnConfig) {
        let _height = btnConfig.width ? btnConfig.width : 80;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      getImageKey(index){
        return 'image'+index
      },
      imageViewUrl() {
        return this.$commonApi.getUrl() + '/upload/preView?Authorization=' + this.$commonApi.getTokenInfo()
      },
      getImagesUrl(id) {
        return this.imageViewUrl() + "&id=" + id
      },
      getImagesUrlList(data) {
        let list = []
        if (data) {
          for (let i = 0; i < data.length; i++) {
            list.push(this.imageViewUrl() + "&id=" + data[i])
          }
        }
        return list;
      },
      getLabelFontSize(){
        let _fontSize = this.chartConfig.labelFontSize;
        if(_fontSize){
          let fontSize = _fontSize / this.page.width * this.screen.width
          return fontSize+'px'
        }else{
          return '14px'
        }
      },
      getControlHeight(height){
        if(!height){
          height=40
        }
        let _height = height / this.page.height * this.screen.height
        return _height+'px'
      },
      getControlFontSize(){
        let _fontSize = this.chartConfig.controlFontSize;
        if(_fontSize){
          let fontSize = _fontSize / this.page.width * this.screen.width
          return fontSize+'px'
        }else{
          return '14px'
        }
      },
      getPadding(){
        let _height = 10;

          let height = _height / this.page.height * this.screen.height
          return height+'px'

      },
      getlableWidth() {
        let _width = this.chartConfig.labelWidth;
        if(_width && _width.indexOf('%')>=0){
          return _width;
        }
        _width=_width?_width:'100px'
        if(_width.indexOf('px')>=0){
          _width=parseInt(_width.replace('px',''))
        }else{
          _width=100
        }
        let width = _width / this.page.width * this.screen.width
        return width+'px'
      },
      getMarginWidthStyle() {
        let _labelWidth=this.getlableWidth()
        return "marginLeft:"+_labelWidth+";"
      },
      itemWidth(col) {
        if (col) {
          return 'el-col-' + col
        } else {
          return 'el-col-24'
        }
      },
      showTitle() {
        if (this.title != null && this.title != undefined && this.title != '') {
          return true
        }
        return false
      }
    }
  }
</script>
<style>

</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  div::-webkit-scrollbar {
    width: 0;
  }
  .customViewFormInfo .label{
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    // line-height: 20px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .customViewFormInfo .item{
        // line-height: 20px;
        position: relative;
        font-size: 14px;
        margin-top: 0;
  }
  .itemClass {
    width: 100% ;
    overflow: hidden; //隐藏文字
    text-overflow: ellipsis; //显示 ...
    white-space: nowrap; //不换行
  }
  .itemTextAreaClass{
    overflow: hidden; //隐藏文字
    line-height: none;
    white-space:normal;
  }



  .title {
    border-left: 4px solid #B463BE;
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/customViewForm.vue